
import { effect, Injectable, signal } from '@angular/core';
import { Theme, ThemeMode } from '@app/layout/default/setting-drawer/setting-drawer.component';

export interface SettingInterface {
  theme: Theme['key']; // Chế độ chủ đề (chế độ tối, chế độ sáng)
  color: string; // Màu chủ đề
  mode: ThemeMode['key']; // Chế độ menu (menu bên, menu trên, menu hỗn hợp)
  colorWeak: boolean; // Chế độ màu yếu
  greyTheme: boolean; // Chế độ xám
  fixedHead: boolean; // Cố định header
  splitNav: boolean; // Tách menu (chỉ áp dụng khi ở chế độ menu hỗn hợp)
  fixedLeftNav: boolean; // Cố định menu bên trái
  isShowTab: boolean; // Hiển thị tab nhiều trang
  fixedTab: boolean; // Cố định tab
  hasTopArea: boolean; // Hiển thị khu vực trên cùng
  hasFooterArea: boolean; // Hiển thị footer
  hasNavArea: boolean; // Có menu
  hasNavHeadArea: boolean; // Menu có header
}

// Chủ đề mặc định, chủ đề tối, chủ đề Aliyun, chủ đề compact
export type StyleTheme = 'default' | 'dark' | 'aliyun' | 'compact';

// Kiểu chủ đề
export type StyleThemeInterface = Record<StyleTheme, boolean>;

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  // todo: Trùng với $themeStyle, cần tối ưu sau
  $isNightTheme = signal(false); // Chủ đề tối
  $isCompactTheme = signal(false); // Chủ đề compact
  $isOverModeTheme = signal(false); // Chế độ over, khi kéo nhỏ trình duyệt menu sẽ ẩn
  $isCollapsed = signal(false); // Chế độ thu gọn menu, kéo nhỏ trình duyệt menu sẽ thu lại thành icon
  $themesOptions = signal<SettingInterface>({
    theme: 'light',
    color: '#1890FF',
    mode: 'side',
    isShowTab: true,
    colorWeak: false,
    greyTheme: false,
    splitNav: false,
    fixedTab: true,
    fixedHead: true,
    fixedLeftNav: true,
    hasTopArea: true,
    hasFooterArea: true,
    hasNavArea: true,
    hasNavHeadArea: true
  });
  $themeStyle = signal<StyleTheme>('default'); // Kiểu chủ đề: tối, mặc định, compact, aliyun
  themeStyleChangeEffect = effect(() => {
    const source = this.$themeStyle();
    this.$isNightTheme.set(source === 'dark');
    this.$isCompactTheme.set(source === 'compact');
  });
}
